
import {reactive, ref, toRefs, watchEffect} from "vue";
import SvgIcon from "@/components/common/SvgIcon.vue";
import i18n from "@/locales";
import {
  getDoc,
  getMemberClubByType,
  getTnc,
  getVICFullName,
  getVICPrefix
} from "@/utils/general";
import Modal from "@/components/common/Modal.vue";
import {MasterDataType} from "@/store/store.type";

const vicCards = [
  {image: "card-basic", title: "VIC", subtitle: "invitation-only"},
  {image: "card-gold", title: "Gold", subtitle: "invitation-only"},
  {image: "card-black", title: "Black", subtitle: "invitation-only"},
]

const bvicNoticeEn = require("@/assets/image/notice-bvic-en.jpeg");
const bvicNoticeZh = require("@/assets/image/notice-bvic-zh.jpeg");
const bvicNoticeSc = require("@/assets/image/notice-bvic-sc.jpeg");

/**
 * Input CSV headers:
 * VICABOUT, VICTNC, VICREG,
 * BVICABOUT, BVICTNC, BVICREG,
 * TVICABOUT, TVICTNC, TVICREG
 */
export default {
  name: "About",
  components: {Modal, SvgIcon},
  props: {
    type: {
      // 0: VIC, 1:BVIC, 2:TVIC
      type: Number,
    },
  },
  setup(props: any) {
    const language = i18n.global.locale;
    const {type} = toRefs(props);
    const typeText = ref("");
    const bvicNotice = ref(language === "sc" ? bvicNoticeSc : language === "zh" ? bvicNoticeZh : bvicNoticeEn)

    const about = ref<any[]>([]);
    const reg = ref("");
    const tnc = ref("");
    const doc = reactive<any>({});

    const updateBVICNotice = (language: string) => {
      // const language = i18n.global.locale;
      bvicNotice.value = language === "sc" ? bvicNoticeSc : language === "zh" ? bvicNoticeZh : bvicNoticeEn;
    }
    updateBVICNotice(i18n.global.locale);

    const init = (typeValue: number) => {
      const prefix = getVICPrefix(typeValue);
      const fullPrefix = getVICFullName(typeValue)
      about.value = doc[prefix + "VICABOUT"].map((obj: any) => {
        const v = obj.split('\n');
        // console.log("v", v);
        // get title
        const result = v.splice(0, 1);
        // console.log("result", result);
        // handle content
        let htmlV = v.map((str: string) => {
          const regex = /^[ |\t]*-/g;
          const found = str.match(regex);
          if (found && found.length > 0) {
            const spaceCount = found[0].split(/[ |\t]/).length - 1;
            return `<li style="margin-left: ${spaceCount * 2}em;">${str.replace(/^[ |\t]*-/g, '').trim()}</li>`;
          } else {
            return str + "\n";
          }
        })?.join("")?.trim();
        if (htmlV.includes("<li")) {
          htmlV = `<ul>${htmlV}</ul>`;
        }
        // console.log("htmlV", htmlV);
        result.push(htmlV);
        return result;
      });
      reg.value = doc[prefix + "VICREG"].join('\n');
      tnc.value = doc[prefix + "VICTNC"].join('\n');
      typeText.value = fullPrefix + "VIC";
    }

    const tncDoc = ref("");

    watchEffect(() => {
      const language = i18n.global.locale;
      const mType = type.value;
      getDoc(language || "en").then((res: any[]) => {
        doc.length = 0;
        Object.assign(doc, res);
        init(mType);
      });

      getTnc(getMemberClubByType(mType), language).then((res: MasterDataType) => {
        tncDoc.value = res.MemberClubInfo.TAC;
      })

      updateBVICNotice(language);
      // getTncDoc(mType, language).then((res: string) => {
      //   tncDoc.value = /<body.*?>([\s\S]*)<\/body>/.exec(res)?.[1] ?? "";
      // })
    });


    const modalOpen = ref(false);
    const onModalOpen = () => {
      modalOpen.value = true;
    }


    return {
      vicCards,
      typeText,
      about,
      reg,
      tnc,
      modalOpen,
      onModalOpen,
      getVICFullName,
      tncDoc,
      bvicNotice,
    }
  }
}
